import { create } from 'zustand';

import { TContentAutomationRunMode } from '../types';

type TContentAutomationStore = {
  isOpen: boolean;
  runningStepIndex?: number;
  runMode?: TContentAutomationRunMode;
  stepStartedAt?: number;
  completedStepIndexes: number[];
  open: () => void;
  close: () => void;
  startStep: (stepIndex: number, runMode: TContentAutomationRunMode) => void;
  completeStep: (stepIndex: number) => void;
};

const useContentAutomationStore = create<TContentAutomationStore>((set) => ({
  isOpen: false,
  runningStepIndex: undefined,
  runMode: undefined,
  stepStartedAt: undefined,
  completedStepIndexes: [],
  open: () => set({ isOpen: true }),
  close: () =>
    set({
      isOpen: false,
      runningStepIndex: undefined,
      runMode: undefined,
      stepStartedAt: undefined,
      completedStepIndexes: [],
    }),
  startStep: (stepIndex, runMode) =>
    set((state) => ({
      isOpen: true,
      runningStepIndex: stepIndex,
      runMode,
      stepStartedAt: Date.now(),
      completedStepIndexes:
        runMode === 'all' && stepIndex === 0
          ? []
          : state.completedStepIndexes.filter((completedStepIndex) => completedStepIndex !== stepIndex),
    })),
  completeStep: (stepIndex) =>
    set((state) => ({
      runningStepIndex: undefined,
      stepStartedAt: undefined,
      completedStepIndexes: state.completedStepIndexes.includes(stepIndex)
        ? state.completedStepIndexes
        : [...state.completedStepIndexes, stepIndex],
    })),
}));

export default useContentAutomationStore;
